import React from 'react';
import CreateTicket from './CreateTicket';
import TicketList from './TicketList';
import Footer from '../view/footer';
import WhatsAppScrollButton from '../view/floatingwhatsApp';
import CircularScrollProgress from '../view/Circularprogress';



const TicketDashboard = () => {
  return (
    <>
      <div className="container" style={{ marginTop: "2rem" }}>

        {/* Row for Create Ticket */}
        <div className="row justify-content-center">
          <div className="col-md-10">
            <div className="card mb-4">
              <div className="card-header bg-gray">
                Create Ticket
              </div>
              <div className="card-body">
                <CreateTicket />
              </div>
            </div>
          </div>
        </div>

        {/* Row for Ticket List */}
        <div className="row justify-content-center">
          <div className="col-md-10">
            <div className="card mb-4">
              <div className="card-header bg-gray ">
                Ticket List
              </div>
              <div className="card-body">
                <TicketList />
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className="space40 bg-white">  </div>
        <WhatsAppScrollButton />
        <Footer />
        <CircularScrollProgress />
      </>
      );
};

      export default TicketDashboard;
